;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { cn } from '@qogita/ui/utils/cn'

export function LoadingDots({
  className,
  variant = 'centered',
}: {
  className?: string
  variant?: 'centered' | 'inline'
}) {
  return (
    <div
      className={cn(
        'flex-row gap-2 p-1',
        {
          'flex items-center justify-center': variant === 'centered',
          'inline-flex': variant === 'inline',
        },
        className,
      )}
    >
      <div className="animation-delay-100 size-1 animate-ping rounded-full bg-gray-900 motion-reduce:animate-none" />
      <div className="animation-delay-100 size-1 animate-ping rounded-full bg-gray-900 motion-reduce:animate-none" />
      <div className="animation-delay-100 size-1 animate-ping rounded-full bg-gray-900 motion-reduce:animate-none" />
    </div>
  )
}
